import MenuItem from '@mui/material/MenuItem'
import React, { useCallback } from 'react'
import { toast } from 'react-toastify'

import { useDeactivateConfiguredService } from 'components/configured-service/layout/useDeactivateConfiguredService'
import T from 'T'
import { handleError } from 'utils/error'

interface ReactivateServiceMenuItemProps {
  configuredServiceId: string
  onDone: () => void
}

// Mounted only while the row menu is open, so one service's details are read rather than all.
const ReactivateServiceMenuItem = ({ configuredServiceId, onDone }: ReactivateServiceMenuItemProps) => {
  const { isServiceDeactivated, isDeactivating, toggleServiceStatus } = useDeactivateConfiguredService(configuredServiceId)

  const handleReactivate = useCallback(async () => {
    await toggleServiceStatus()
      .then(() => toast.success(T.SERVICE_REACTIVATED))
      .catch(handleError)
    onDone()
  }, [toggleServiceStatus, onDone])

  if (!isServiceDeactivated) return null

  return (
    <MenuItem disabled={isDeactivating} onClick={handleReactivate}>
      {T.REACTIVATE}
    </MenuItem>
  )
}

export default ReactivateServiceMenuItem
